import axios from 'axios';
import tracing from './tracing.js';

export default {
  consoleDebug:function(anyValue,group = undefined){
    if (process.env.VUE_APP_DEBUG_CONSOLE === 'true') {
      if (group != undefined) {
        if (group === 'open') {
          console.group(anyValue);
        }
        if (group === 'close') {
          console.groupEnd(anyValue);
        }
      } else {
        console.log(anyValue);
      }
    }
  },
  run:function (sendData) {
    let actionName = (sendData.action !== undefined) ? sendData.action:'';
    this.consoleDebug('external '+ actionName,'open');
    return new Promise((resolve, reject) => {
      this.zita(sendData)
        .then(res=>{
          this.consoleDebug('then '+ actionName);
          this.consoleDebug(res);
          resolve(res)
        }).catch((res)=>{
          this.consoleDebug('cath '+ actionName);
          this.consoleDebug(res);
        reject(res)
      }).finally(()=>{
        this.consoleDebug('external '+ actionName,'close');
      });
    });
  },
  zita:function (sendData) {
    this.consoleDebug('zita','open');
    return new Promise((resolve, reject) => {
      // sendData.session_id = parseInt(sessionStorage.getItem('session_id'), 10);
      sendData.session_id =  window.session_id;
      axios({
        method: 'post',
        url: process.env.VUE_APP_URL_ZITA,
        data: sendData
      }).then((res)=>{
        this.consoleDebug('then');
        this.consoleDebug(res);
        try {
          if (res.data.errorCode === 0 && res.data.result.Error.Code === 0) {
            setTimeout(()=>{
              this.gita(res.data.result.Result, res.data.result.bindi)
              .then((res)=>resolve(res)).catch((res)=>reject(res));
            },1000);
          } else {
            reject(res.data);
          }
        } catch (e) {
          reject(e.toString());
        }
      }).catch((res)=>{
        this.consoleDebug('cath');
        this.consoleDebug(res);
        reject(res);
      }).finally(()=>{
        this.consoleDebug('zita','close');
      });
    });
  },
  gita:function (hindi,bindi) {
    return  new Promise((resolve, reject) => {
      this.consoleDebug('gita','open');
      axios({
        method: 'post',
        url: process.env.VUE_APP_URL_GITA,
        data: {
          hindi:hindi,
          bindi:bindi
        }
      }).then(res=>{
        this.consoleDebug('then');
        if (res.data.errorCode === 0 && res.data.result.error.code === 0) {
          resolve(res.data.result.result);
        } else if (res.data.errorCode === 0 && res.data.result.error.code === 1) {
          setTimeout(()=>{
            this.gita(hindi,bindi)
            .then((res)=>resolve(res)).catch((res)=>reject(res));
          },1000);
        } else {
          reject(res.data)
        }
      }).catch(res=>{
        this.consoleDebug('catch');
        reject(res);
      }).finally(()=>{
        this.consoleDebug('gita','close');
      })
    });
  },
  traceInputDelayList:function(objForSend){
    let forSend = JSON.stringify(objForSend);
    if (window.traceDelay !== undefined && window.traceDelay.length > 0) {
      let resultScan = false;
      for(let i=0;i<window.traceDelay.length;i+=1) {
        if (window.traceDelay[i].refs === objForSend.refs && window.traceDelay[i].action === objForSend.action) {
          resultScan = true;
          // есть такое поле
          if (window.traceDelay[i].forSend === forSend) {
            //данные не изменились, обновим таймер
            window.traceDelay[i].time = new Date().getTime();
          } else {
            //данные изменились
            window.traceDelay[i].time = new Date().getTime();
            window.traceDelay[i].forSend = forSend
          }
        }
      }
      if (!resultScan) {
        //в очереди такого нет
        window.traceDelay.push({
          time: new Date().getTime(),
          refs: objForSend.refs,
          action: objForSend.action,
          forSend:forSend
        });
      }
    } else {
      window.traceDelay = [{
        time: new Date().getTime(),
        refs: objForSend.refs,
        action: objForSend.action,
        forSend:forSend
      }]
    }
  },
  tryLogInput:function(){
    // console.group('taimer')
    for(let i =0; i < window.traceDelay.length; i+=1){
      if (new Date().getTime() - window.traceDelay[i].time  >= 1500) {
        let sklad = JSON.parse(window.traceDelay[i].forSend);
        axios({
          method: 'post',
          url: process.env.VUE_APP_URL_TRACE,
          data: sklad
        });
        window.traceDelay.splice(i, 1);
      }
    }
    // console.groupEnd('taimer')
  },
  traceInput: tracing.traceInput,
};
